import { useEffect } from "react";
import { useAuth } from "@/providers/AuthProvider";
import { useTheme } from "@/providers/ThemeProvider";

interface TenantThemeProviderProps {
  children: React.ReactNode;
}

export function TenantThemeProvider({ children }: TenantThemeProviderProps) {
  const { currentTenant } = useAuth();
  const { setPrimaryColor, setGrayColor, setRadius } = useTheme();

  useEffect(() => {
    if (currentTenant?.theme_settings?.primary_color) {
      setPrimaryColor(currentTenant.theme_settings.primary_color);
    } else {
      // Default to orange if no tenant theme is set
      setPrimaryColor("orange");
    }

    if (currentTenant?.theme_settings?.gray_color) {
      setGrayColor(currentTenant.theme_settings.gray_color);
    } else {
      // Default to gray if no tenant gray is set
      setGrayColor("gray");
    }

    if (currentTenant?.theme_settings?.radius) {
      setRadius(currentTenant.theme_settings.radius);
    } else {
      setRadius("none");
    }
  }, [currentTenant, setPrimaryColor, setGrayColor, setRadius]);

  return <>{children}</>;
}
